export function SectionEyebrow({ num, name }: { num: string; name: string }) {
  return (
    <div className="section-eyebrow">
      <span className="num">{num}</span>
      <span className="name">{name}</span>
      <span className="bar" />
    </div>
  );
}
